module.exports = __webpack_public_path__ + "img/046.2f47e3a6.jpg";